module.exports = __webpack_public_path__ + "img/qiyexiangce.cd29bad5.png";